import { render, staticRenderFns } from "./CrossIconHover.vue?vue&type=template&id=386a3fa8"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386a3fa8')) {
      api.createRecord('386a3fa8', component.options)
    } else {
      api.reload('386a3fa8', component.options)
    }
    module.hot.accept("./CrossIconHover.vue?vue&type=template&id=386a3fa8", function () {
      api.rerender('386a3fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrossIconHover.vue"
export default component.exports